import { Dictionary } from "vue-router/types/router";

import ApiService from "@/modules/api/api.service";

export default class CustomerPreviewRepository {
  constructor(private api: ApiService) {}

  public async createCustomerPreviewApprovement(
    plushieId: string
  ): Promise<string> {
    await this.api.post(`/customer_previews/approvements`, {
      plushieId,
    });

    return plushieId;
  }

  public async createCustomerPreviewRejection(
    plushieId: string,
    comment: string,
    attachments: string[]
  ): Promise<string> {
    const data: Dictionary<string | string[]> = {
      plushieId,
      comment,
    };

    if (attachments.length > 0) {
      data.attachmentIds = attachments;
    }

    await this.api.post(`/customer_previews/rejections`, data);

    return plushieId;
  }

  public async undoCustomerPreviewApprovement(
    plushieId: string
  ): Promise<string> {
    await this.api.post(`/customer_previews/in_progress`, {
      plushieId,
    });

    return plushieId;
  }
}
